<template>
  <div class="control-list">
    <b-table
      :fields="fields"
      :items="cars"
      :striped="true"
      :borderless="true"
      sticky-header="600px"
      responsive="sm"
      id="table-control"
    >
      <template v-slot:cell(picture)="inventory">
        <b-img-lazy
          :src="imageSizing(inventory.item.pictures_main, 'small')"
          width="100"
        ></b-img-lazy>
      </template>
      <template v-slot:cell(start)="inventory">
        <b-button
          variant="success"
          :disabled="buttonsDisabled"
          v-if="inventory.item.bid_status === 'on'"
          v-on:click="auctionStart(inventory.item.id)"
          >Iniciar {{ inventory.item.item }}</b-button
        >
      </template>
      <template v-slot:cell(status)="inventory">
        <Status :status="inventory.item.bid_status" />
      </template>
      <template v-slot:cell(bid)="inventory">
        <b-input
          size="xs"
          v-if="inventory.item.edit && inventory.item.edit.bid"
          :value="inventory.unformatted"
          v-focus
          v-on:blur="
            saveEditable(inventory.item.item, 'bid', $event.target.value)
          "
          v-on:keyup.enter="saveEditable(inventory.item.item, 'bid', 0)"
        />
        <div v-else>
          <label v-on:click="makeEditable(inventory.item, 'bid')">{{
            inventory.value
          }}</label>
        </div>
      </template>
      <template v-slot:cell(bidAffiliate)="inventory">
        <b-input
          size="xs"
          v-if="inventory.item.edit && inventory.item.edit.bidAffiliate"
          :value="inventory.unformatted"
          v-focus
          v-on:blur="
            saveEditable(
              inventory.item.item,
              'bidAffiliate',
              $event.target.value
            )
          "
          v-on:keyup.enter="
            saveEditable(inventory.item.item, 'bidAffiliate', 0)
          "
        />
        <div v-else>
          <label v-on:click="makeEditable(inventory.item, 'bidAffiliate')">{{
            inventory.value
          }}</label>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import Status from "./item/Status";
import utils from "../assets/js/utils";

export default {
  name: "ControlList",
  components: { Status },
  data() {
    return {
      cars: [],
      carIndex: {},
      buttonsDisabled: false,
      fields: [
        {
          key: "item",
          label: "Partida",
          sortable: true,
          stickyColumn: true,
          class: "text-center",
        },
        {
          key: "picture",
          label: "Foto",
          stickyColumn: true,
          class: "text-center",
        },
        {
          key: "code",
          label: "Código",
          sortable: true,
          stickyColumn: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "",
          stickyColumn: true,
          class: "text-center",
        },
        {
          key: "start",
          label: "",
          stickyColumn: true,
          class: "text-center",
        },
        {
          key: "brand",
          label: "Marca / Diverso",
          sortable: true,
        },
        {
          key: "make",
          label: "Línea",
          sortable: true,
        },
        {
          key: "model",
          label: "Modelo",
          class: "text-right",
        },
        {
          key: "color",
          label: "Color",
        },
        {
          key: "base",
          label: "Base",
          class: "text-right",
          formatter: "currency",
        },
        {
          key: "minimum",
          label: "Mínimo",
          class: "text-right",
          formatter: "currency",
        },
        {
          key: "bid",
          label: "Oferta",
          class: "text-right",
          formatter: "currency",
        },
        {
          key: "bidAffiliate",
          label: "Afiliado",
          sortable: true,
          class: "text-center",
          formatter: "affiliateCode",
        },
      ],
    };
  },
  created: async function () {
    this.cars = await utils.loadCars(this, null, false, true);
    await utils.asyncForEach(this.cars, async (car) => {
      if (!car) return;
      this.carIndex[car.id] = car.item;
      car.edit = { bid: false, bidAffiliate: false };
    });
  },
  watch: {
    // Watch for WebSocket messages from the store
    '$store.getters.socketMessage': {
      handler: function(message) {
        if (!message || !message.message || !message.message.action) {
          return;
        }

        switch (message.message.action) {
          case "auctionStarts":
            {
              if (
                !message.message.carId ||
                !this.carIndex[message.message.carId]
              )
                return;

              this.cars[this.carIndex[message.message.carId]].bid_status =
                "almost";
              this.buttonsDisabled = true;
            }
            break;

          case "auctionBump":
            {
              if (
                !message.message.carId ||
                !this.carIndex[message.message.carId]
              )
                return;

              const carItem = this.carIndex[message.message.carId];
              this.cars[carItem].bid_status = "almost";
              this.cars[carItem].bidAffiliate =
                message.message.affiliateCode;
              this.cars[carItem].bid = message.message.bid;
              this.buttonsDisabled = true;
            }
            break;

          case "auctionEnds": {
            if (
              !message.message.carId ||
              !this.carIndex[message.message.carId]
            )
              return;

            const carItem = this.carIndex[message.message.carId];
            this.cars[carItem].bid_status = "off";
            this.cars[carItem].bidAffiliate = message.message.affiliateCode;
            this.cars[carItem].bid = message.message.bid;
            this.buttonsDisabled = false;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    makeEditable: function (car, element) {
      if (car.bid_status === "almost") return;
      car.edit[element] = true;
      this.$root.$emit("bv::refresh::table", "table-control");
    },
    saveEditable: function (item, element, value) {
      this.cars[item].edit[element] = false;
      if (this.cars[item].bid_status === "almost") return;
      if (value !== null && value === parseInt(value).toString()) {
        this.cars[item][element] = value;

        switch (element) {
          case "bid":
            utils.changeBidOnly(this, this.cars[item].code, parseInt(value));
            break;
          case "bidAffiliate":
            utils.changeBidAffiliateOnly(
              this,
              this.cars[item].code,
              parseInt(value)
            );
            break;
        }
      }
      this.$root.$emit("bv::refresh::table", "table-control");
    },
    currency: function (value) {
      return utils.formatCurrency(value);
    },
    auctionStart: async function (id) {
      utils.auctionStart(this, id);
    },
    imageSizing: function (images, size) {
      if (!images || !images.length)
        return (
          "https://db97aqbgbmp5i.cloudfront.net/images/inv-generic-" +
          size +
          ".jpg"
        );

      if (images[0] === "")
        return (
          "https://db97aqbgbmp5i.cloudfront.net/images/inv-generic-" +
          size +
          ".jpg"
        );
      return (
        "https://db97aqbgbmp5i.cloudfront.net/images/inv/" +
        size +
        "/" +
        images[0]
      );
    },
    affiliateCode: function (code) {
      if (code) return code;
      return "---";
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
        el.select();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";
</style>
